module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 38
// module chunks = 9